module.exports = __webpack_public_path__ + "img/reset.a79ee6a9.png";